import {SceneProcessingState} from '../TourBuilderLibrary/domain/types/Scene';

export function convertToProcessingState(serverProcessingState: boolean | null): SceneProcessingState {
  if (!serverProcessingState) {
    return 'processing';
  }

  return serverProcessingState === true ? 'success' : 'failed';
}
